export const referralProgramConfigurationMessages = {
  pageTitle: 'Configure Referral Program',
  pageSubtitle: 'Create and incentivize the use of referral codes',

  confirmationDialogCancelButtonText: 'Cancel',
  confirmationDialogConfirmButtonText: 'Confirm',
  submitConfirmationDialogDescription:
    'The referral program you are editing is currently live. Please confirm you would like to proceed with your changes.',
  cancelConfirmationDialogDescription:
    'There are unsaved changes. If you continue, these changes will be lost.',
  cancelConfirmationDialogConfirmButtonText: 'Continue',
  configurationSuccessMessage: 'Your changes have been successfully saved.',
};
